import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { clearCustomerSession, getCustomerSession } from './customerSession';
import './PublicHome.css';

const PUBLIC_HEADER_LOGO_URL =
  'https://ogtwmrdpuaofpcmpeguz.supabase.co/storage/v1/object/public/logo/WhatsApp_Image_2026-04-12_at_4.48.39_PM-removebg-preview%20(1).png';

function PublicHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const closeMobileMenu = () => setMobileMenuOpen(false);
  const onContact = location.pathname === '/contact';
  const onAbout = location.pathname === '/about';
  const onSignIn = location.pathname === '/sign-in';
  const onSignUp = location.pathname === '/sign-up';
  const onAccount = location.pathname === '/account';

  const [customer, setCustomer] = React.useState(() => getCustomerSession());

  React.useEffect(() => {
    const sync = () => setCustomer(getCustomerSession());
    sync();
    window.addEventListener('odus-customer-session', sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener('odus-customer-session', sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  const customerFirstName = () => {
    const n = (customer?.fullName || '').trim().split(/\s+/)[0];
    return n || 'there';
  };

  const handleCustomerSignOut = () => {
    clearCustomerSession();
    setCustomer(null);
    closeMobileMenu();
    if (
      location.pathname === '/sign-in' ||
      location.pathname === '/sign-up' ||
      location.pathname === '/account'
    ) {
      navigate('/');
    }
  };

  React.useEffect(() => {
    if (!mobileMenuOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') setMobileMenuOpen(false);
    };
    window.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [mobileMenuOpen]);

  return (
    <header
      className={`ph-nav${mobileMenuOpen ? ' ph-nav--menu-open' : ''}`}
    >
      <div className="ph-nav-inner">
        <Link to="/" className="ph-brand" onClick={closeMobileMenu}>
          <img
            src={PUBLIC_HEADER_LOGO_URL}
            alt="ODUS — curated rentals"
            className="ph-brand-logo"
            width={200}
            height={88}
            decoding="async"
          />
          <span className="ph-visually-hidden">ODUS</span>
        </Link>
        <nav className="ph-nav-links ph-nav-links--desktop" aria-label="Primary">
          <Link
            to="/about"
            className={`ph-nav-link${onAbout ? ' ph-nav-link--active' : ''}`}
          >
            About us
          </Link>
          <Link
            to="/contact"
            className={`ph-nav-link${onContact ? ' ph-nav-link--active' : ''}`}
          >
            Contact us
          </Link>
          {customer ? (
            <>
              <span className="ph-customer-greet" title={customer.email}>
                Hi, {customerFirstName()}
              </span>
              <Link
                to="/account"
                className={`ph-nav-link${onAccount ? ' ph-nav-link--active' : ''}`}
              >
                Profile
              </Link>
              <button
                type="button"
                className="ph-btn ph-btn-ghost"
                onClick={handleCustomerSignOut}
              >
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link
                to="/sign-in"
                className={`ph-nav-link${onSignIn ? ' ph-nav-link--active' : ''}`}
              >
                Sign in
              </Link>
              <Link
                to="/sign-up"
                className={`ph-nav-link${onSignUp ? ' ph-nav-link--active' : ''}`}
              >
                Sign up
              </Link>
            </>
          )}
        </nav>
        <div className="ph-nav-mobile">
          <button
            type="button"
            className={`ph-m-toggle ${mobileMenuOpen ? 'ph-m-toggle--open' : ''}`}
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileMenuOpen}
            onClick={() => setMobileMenuOpen((o) => !o)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
      {mobileMenuOpen && (
        <>
          <div className="ph-m-panel" role="dialog" aria-label="Menu">
            <Link to="/" className="ph-m-link" onClick={closeMobileMenu}>
              Home
            </Link>
            <Link
              to="/about"
              className={`ph-m-link${onAbout ? ' ph-m-link--active' : ''}`}
              onClick={closeMobileMenu}
            >
              About us
            </Link>
            <Link
              to="/contact"
              className={`ph-m-link${onContact ? ' ph-m-link--active' : ''}`}
              onClick={closeMobileMenu}
            >
              Contact us
            </Link>
            {customer ? (
              <>
                <div className="ph-m-customer" role="status">
                  Signed in as <strong>{customer.email}</strong>
                </div>
                <Link
                  to="/account"
                  className={`ph-m-link${onAccount ? ' ph-m-link--active' : ''}`}
                  onClick={closeMobileMenu}
                >
                  Profile
                </Link>
                <button
                  type="button"
                  className="ph-m-link ph-m-link--signout"
                  onClick={handleCustomerSignOut}
                >
                  Sign out
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/sign-in"
                  className={`ph-m-link${onSignIn ? ' ph-m-link--active' : ''}`}
                  onClick={closeMobileMenu}
                >
                  Sign in
                </Link>
                <Link
                  to="/sign-up"
                  className={`ph-m-link${onSignUp ? ' ph-m-link--active' : ''}`}
                  onClick={closeMobileMenu}
                >
                  Sign up
                </Link>
              </>
            )}
          </div>
          <button
            type="button"
            className="ph-m-backdrop"
            aria-label="Close menu"
            onClick={closeMobileMenu}
          />
        </>
      )}
    </header>
  );
}

export default PublicHeader;
